import React, { useCallback, useEffect } from 'react';
import Marquee from 'react-fast-marquee';
import {
  SEARCH_EVENTS,
  sendBannerEvents,
} from '../../../helpers/analytics/search.analytics';
import './Announcement.scss';

const setTargetBlankForLinks = (text) => {
  let newText = '',
    flag = 0;
  if (!text) return <></>;
  for (let i = 0; i < text.length; i++) {
    if (text[i] === '<' && i + 1 < text.length && text[i + 1] === 'a') {
      flag = 1;
    }
    if (text[i] === '>' && flag === 1) {
      newText += ` target="_blank"`;
      flag = 0;
    }
    newText += text[i];
  }
  return `<span>${newText}</span>`;
};

const Announcement = ({ announcements }) => {
  useEffect(() => {
    sendBannerEvents(SEARCH_EVENTS.BANNER_TRAIL_VISIBLE_EVENT);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendJumboEvent = useCallback(
    (announcement) => (event) => {
      if (event?.target?.tagName === 'A') {
        sendBannerEvents(SEARCH_EVENTS.BANNER_CLICK_EVENT, {
          banner: JSON.stringify(announcement),
          anchor_text: String(event?.target.text),
        });
      }
    },
    [],
  );

  return (
    <div className='bannersWrapper'>
      <Marquee
        gradient={false}
        pauseOnHover={true}
        pauseOnClick={true}
        speed={30}
        delay={3}
        style={{
          border: 'none',
        }}
      >
        <div
          className='slide-track'
          css={`
            & p {
              white-space-collapse: preserve !important;
            }
          `}
        >
          {announcements &&
            announcements.map((announcement) => (
              <div
                className='notification-bar'
                key={announcement['id']}
                dangerouslySetInnerHTML={{
                  __html: setTargetBlankForLinks(
                    announcement['announcement_text'],
                  ),
                }}
              ></div>
            ))}
        </div>
      </Marquee>
    </div>
  );
};

export default Announcement;
